import React, { FunctionComponent, PropsWithChildren } from 'react';

import { default as MuiCheckbox, CheckboxProps } from '@mui/material/Checkbox';

const Checkbox: FunctionComponent<CheckboxProps> = (
  props: PropsWithChildren<CheckboxProps>
) => {
  return <MuiCheckbox {...props}></MuiCheckbox>;
};

export default Checkbox;
